import React from 'react'
import { Outlet } from 'react-router-dom'

const QueryTracker = () => {
  return (
    <><Outlet/></>
  )
}

export default QueryTracker